// ページトップ
$(function() {
	var pagetop = $('#page-top');
	pagetop.hide();
	$(window).scroll(function() {
		if ($(this).scrollTop() > 100) {
			pagetop.fadeIn();
		} else {
			pagetop.fadeOut();
		}
	});
	pagetop.click(function() {
		$('body, html').animate({
			scrollTop: 0
		}, 500);
		return false;
	});
});

// ページ内リンク（同ページ）
$(function(){
	$('a[href*=\\#]:not([href=\\#])').click(function() {
	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var $target = $(this.hash);
			$target = $target.length && $target || $('[name=' + this.hash.slice(1) +']');
			$headerHeight = $('.header_content').outerHeight()
			if ($target.length) {
				var targetOffset = $target.offset().top  - $headerHeight;
				$('html,body').animate({scrollTop: targetOffset}, 1000);
			return false;
			}
		}
	});
});

// ページ内リンク（別ページ）
$(function(){
	const hash = location.hash;
	if(hash){
		$("html, body").stop().scrollTop(0);
		setTimeout(function(){
			$target = $(hash)
			$headerHeight = $('.header_content').outerHeight()
			var targetOffset = $target.offset().top - $headerHeight;
			$("html, body").animate({scrollTop: targetOffset}, 1000);
		});
	}
});

// ローディングアニメーション
$(window).on('load',function(){
  $("#splash").delay(1500).fadeOut('slow');
  $("#splash_logo").delay(1200).fadeOut('slow');
});

// メインビジュアルスライダー
const mainvisualSlider = new Swiper('.mainvisual_img', {
	effect: 'fade',
	fadeEffect: {
		crossFade: true,
	},
	autoplay: {
    delay: 4000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
	loop: true,
    loopAdditionalSlides: 1, 
	speed: 4000,
});

// トップギフトスライダー
const giftSwiper = new Swiper('.top_gift-list', {
  slidesPerView: 1.25,
  spaceBetween: 15,
  centeredSlides: true,
  loop: true,
  loopAdditionalSlides: 1,
  speed: 1000,
  grabCursor: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    600: {
      slidesPerView: 2,
    },
    1025: {
        slidesPerView: 2.6,
    }
  },

});

// 商品詳細スライダー
const mySwiper_thumb = new Swiper('.product_sub-slider', {
  slidesPerView: 5,
  spaceBetween:10,
  grabCursor: true,
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});

const mySwiper_main = new Swiper('.product_main-slider', {
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  loopAdditionalSlides: 1,
  speed: 500,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  thumbs: {
    swiper: mySwiper_thumb,
  },
});

// ヘッダー背景色
$(function () {
  $(window).on('scroll', function () {
    if ($('#mainvisual').height() < $(this).scrollTop()) {
        $('.header_content').addClass('color');
    } else {
        $('.header_content').removeClass('color');
    }
  });
});